import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { apiService } from 'src/app/service/api.service';
import { ValidacionService } from 'src/app/service/validacion.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { MatDialog } from '@angular/material/dialog';


import { ModalVideoComponent } from '../dialogs/modal-video/modal-video.component';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ModalEvaluacionConfidencialComponent } from './components/modal-evaluacion-confidencial/modal-evaluacion-confidencial.component';
import { ModalActaComponent } from './components/modal-acta/modal-acta.component';

@Component({
  selector: 'app-jardin-validacion-externa',
  templateUrl: './jardin-validacion-externa.component.html',
  styleUrls: ['./jardin-validacion-externa.component.css']
})
export class JardinValidacionExternaComponent implements OnInit {

  jornada1FechaHoraView;
  jornada2FechaHoraView;
  fechaActaValidacion;
  classEstado;
  proceso
  linkEntrevista;
  activaModelActa: boolean = false;
  one: boolean = true;
  two: boolean = false;
  three: boolean = false;
  activaPaso2:boolean = false;
  estadoValidacion:number;
  estadoEvaluacion:string= "En Curso ";
  fechaEvaluacion:Date;
  estadoEvaluacionButton:string= "Evaluar";
  estadoClase = 'estado en-curso'
  actaFirmada="Firmar"
  actaIniciada:boolean= true;
  jardinPeriodoInforme:any;
  showApelacion;


  constructor(
    private spinner: NgxSpinnerService, 
    private validacionService: ValidacionService, 
    private api: apiService,
    private modal: NgbModal,
    public dialog: MatDialog) {}

  ngOnInit() {
    this.showApelacion = false;
    this.getAgendar();
    this.getEstadoValidacion();
    this.getJardinPeriodoInforme();
    this.getActa();
    this.getEvaluacion();

  }

  getJardinPeriodoInforme(){
    const param = this.api.dataJardin.idJardinPeriodo;
    this.validacionService.API_POST_getDataInformeValidacion(param).subscribe(result => {
      this.jardinPeriodoInforme = result.payload;
      if(this.jardinPeriodoInforme.fechaVistaInformeRestultados != null){
        let fecha = new Date(this.jardinPeriodoInforme.fechaVistaInformeRestultados);
        this.jardinPeriodoInforme.fechaVistaInformeRestultados = fecha;
      }
      if(this.jardinPeriodoInforme.fechaLimiteApelacion != null){
        let fecha = new Date(this.jardinPeriodoInforme.fechaLimiteApelacion);
        this.jardinPeriodoInforme.fechaLimiteApelacion = fecha;
      }
      if(this.jardinPeriodoInforme.fechaInformeRetroalimentacion != null){
        let fecha = new Date(this.jardinPeriodoInforme.fechaInformeRetroalimentacion);
        this.jardinPeriodoInforme.fechaInformeRetroalimentacion = fecha;
      }

    }, (err) => {
      console.log(err);
    });
  }

  getEstadoValidacion(){
    const param = this.api.dataJardin.idJardinPeriodo
    this.validacionService.API_POST_getEstadoValidacion(param).subscribe(result => {
      this.estadoValidacion = result.payload;
    }, (err) => {
      this.estadoValidacion = 0;
      console.log(err);
    });
  }




  tab1() {
    this.one = true;
    if(this.one = true) {
      this.two = false;
      this.three = false;
    }
  }
  tab2() {
    this.two = true;
    if(this.two = true) {
      this.one = false;
      this.three = false;
    }
  }
  tab3() {
    this.three = true;
    if(this.three = true) {
      this.one = false;
      this.two = false;
    }
  }


  getAgendar() {
    const param = this.api.dataJardin.idJardinPeriodo
    this.validacionService.API_POST_getAgendarJardin(param).subscribe(result => {
      if (result.payload) {
        this.jornada1FechaHoraView = result.payload.fechaJornada1 ? new Date(result.payload.fechaJornada1) : null;
        this.jornada2FechaHoraView = result.payload.fechaJornada2 ? new Date(result.payload.fechaJornada2) : null;
        this.linkEntrevista = result.payload.linkZoom
        this.activaPaso2 = true;
      } else {
        this.jornada1FechaHoraView = null;
        this.jornada2FechaHoraView = null;
      }
    }, (err) => {
      console.log(err);
    });
  }

  modalActaView(){

      const dialogRef = this.dialog.open(ModalActaComponent ,{
        disableClose: true ,
        data: {dataResumen: ''},
        width: '65%',
      });

      dialogRef.afterClosed().subscribe(result => {
        this.getActa();
      });
    }

  modalEvaluacionConfidencialView(){
      const dialogRef = this.dialog.open(ModalEvaluacionConfidencialComponent ,{
        disableClose: true ,
        data: {dataResumen: ''},
        width: '68%',
      });

      dialogRef.afterClosed().subscribe(result => {
        this.getEvaluacion();
      });

    }
  

  mostrarCartaPresentacion(){
    var pdfDocumentSrc = environment.apiEndpoint + "validacion/getCartaPresentacion/" + this.api.dataJardin.idJardinPeriodo;
    const dialogRef = 
    this.dialog.open(ModalVideoComponent, {
      disableClose: true ,
      data: {url: pdfDocumentSrc ,size: 'xl'}
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  verVideo(nombre){
    switch(nombre){
      case 'instructivo':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/validacion/ZoomVF.pdf',size: 'xl'}
          });
  
          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      } 
    }
  }


  getActa(){
    const param = this.api.dataJardin.idJardinPeriodo
    this.validacionService.API_POST_getActaValidacion(param).subscribe((response: any) => {
      if(response.payload.idEstado == null){
        this.proceso = 'En Curso';
        this.classEstado = "estado en-curso"
     
        this.actaIniciada = false
        
        return;
      }

      if (response.payload.idActaValidacion){      
        this.actaIniciada = true
        this.fechaActaValidacion = response.payload.fechaActa ? new Date(response.payload.fechaActa) : null;
        this.proceso = 'Disponible'
        this.classEstado = "estado disponible"
        this.estadoValidacion = response.payload.idEstado;

        if(this.estadoValidacion ==1){
          this.proceso = 'Firmada'
          this.actaFirmada = 'Revisar'

        }


      }else{
        this.proceso = 'En Curso';
        this.classEstado = "estado en-curso"
      }
      },
    (err) => {
      console.log("error"+err)
      this.proceso = 'En Curso';
      this.classEstado = "estado en-curso"
      this.actaIniciada = false

    });
  
  }


  getEvaluacion(){
    const param = this.api.dataJardin.idJardinPeriodo
    this.validacionService.API_POST_getEvaluacionValidacion(param).subscribe((response: any) => {
      if(response.payload.nota1 === null && response.payload.nota2 === null && response.payload.nota3 === null){
        return
      } 

      this.estadoEvaluacion = 'Realizada'
      this.estadoEvaluacionButton = 'Revisar'
      this.estadoClase = 'estado disponible'
      this.fechaEvaluacion = response.payload.fechaEvaluacionValidacion;
      },
    (err) => {
      console.log("error"+err)
    });
  
  }


  verInformeResultados(){
    if(this.jardinPeriodoInforme.informeResultadosVisto){
      this.spinner.show();
      this.showInformeResultados();
    }else{
      Swal.fire({
        title: '¡Atención!',
        html: 'Recuerde que tiene <b>3 días hábiles para apelar</b> a sus resultados de forma opcional.',
        showCancelButton: true,
        confirmButtonText: 'OK, COMPRENDO',
        cancelButtonText: 'VOLVER',
        confirmButtonColor: '#00B09E',
        cancelButtonColor: '#30374B',
      }).then((result) => {
        if (result.isConfirmed) {      
          this.registrarVistaInformeResultados();         
        }
      })
    }
  }

  


  registrarVistaInformeResultados(){
    this.spinner.show();
    const param = this.api.dataJardin.idJardinPeriodo
    this.validacionService.API_POST_registrarVistaInformeResultados(param).subscribe((response: any) => {
      this.jardinPeriodoInforme = response.payload;
      if(this.jardinPeriodoInforme.fechaVistaInformeRestultados != null){
        let fecha = new Date(this.jardinPeriodoInforme.fechaVistaInformeRestultados);
        fecha.setTime( fecha.getTime() + fecha.getTimezoneOffset()*60*1000 );
        this.jardinPeriodoInforme.fechaVistaInformeRestultados = fecha;
      }
      if(this.jardinPeriodoInforme.fechaLimiteApelacion != null){
        let fecha = new Date(this.jardinPeriodoInforme.fechaLimiteApelacion);
        fecha.setTime( fecha.getTime() + fecha.getTimezoneOffset()*60*1000 );
        this.jardinPeriodoInforme.fechaLimiteApelacion = fecha;
      }
      this.showInformeResultados();
    },
    (err) => {
      console.log("error"+err)
    });
  }

  showInformeResultados(){
    this.spinner.show();
    const param = this.api.dataJardin.idJardinPeriodo
    var pdfDocumentSrc = environment.apiEndpoint + "validacion/showInformeResultados/" + param;
    const dialogRef = 
    this.dialog.open(ModalVideoComponent, {
      disableClose: true ,
      data: {url: pdfDocumentSrc ,size: 'xl'}
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  showInformeRetroalimentacion(){
    this.spinner.hide();
    const param = this.api.dataJardin.idJardinPeriodo
    var pdfDocumentSrc = environment.apiEndpoint + "validacion/showInformeRetroalimentacion/" + param;
    const dialogRef = 
    this.dialog.open(ModalVideoComponent, {
      disableClose: true ,
      data: {url: pdfDocumentSrc ,size: 'xl'}
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  showApelacionJardin(){
    if(this.jardinPeriodoInforme.envioApeliacion){
      this.showApelacion = true;  
    }else{
      Swal.fire({
        html: 'Para apelar, seleccione el Área, Dimensión y Elemento de Gestión deseado. Luego, en "¿Desea apelar?" marque "Sí", para que se active el campo de texto y pueda detallar qué descriptores considera que están certificados, justificando de acuerdo a los Medios de verificación presentados. Recuerde ser precisa en su argumentación.',
        showCancelButton: false,
        confirmButtonText: 'OK, COMPRENDO',
        confirmButtonColor: '#00B09E',
      }).then((result) => {
        if (result.isConfirmed) {      
          this.showApelacion = true;        
        }
      })
    }

  }

}

